import dayjsInstance, { type PluginFunc } from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isToday from 'dayjs/plugin/isToday'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

// Relative time when recent; absolute date once ~a month out (year only when not the current year).
const relativeOrDate: PluginFunc = (_option, DayjsClass, dayjsFactory) => {
  DayjsClass.prototype.formatRelativeOrDate = function (this: dayjsInstance.Dayjs) {
    const now = dayjsFactory()
    if (Math.abs(now.diff(this, 'day')) <= 25) return this.fromNow()
    return this.year() === now.year() ? this.format('MMM D') : this.format('MMM D, YYYY')
  }
}

dayjsInstance.extend(calendar)
dayjsInstance.extend(isSameOrAfter)
dayjsInstance.extend(isSameOrBefore)
dayjsInstance.extend(isToday)
dayjsInstance.extend(quarterOfYear)
dayjsInstance.extend(relativeTime)
dayjsInstance.extend(utc)
dayjsInstance.extend(relativeOrDate)

export const dayjs = dayjsInstance

export type Dayjs = dayjsInstance.Dayjs

declare module 'dayjs' {
  interface Dayjs {
    formatRelativeOrDate(): string
  }
}
